<template>
  <div class="dashboard background">
    <date-picker v-model="startDate"
      element="startDate"></date-picker>
    <date-picker
      v-model="endDate"
      element="endDate"></date-picker>
    <date-picker
      v-model="classDate"
      type="datetime"
      element="classDate"></date-picker>
    <toast />
    <dashboard-page pcontent="1" page="COURSES">
      <!-- course manager  -->
      <card w='80%' minWidth='950px' v-if='true'>
        <!-- card header -->
        <div class='fRow fullWidth jStart aCenter' style="margin-bottom: 16px">
          <div class='growFull fCol jStart aStart'>
            <h3 class='growFull text-right'>مدیریت کاربرها</h3>
            <p class='note'>برای ایجاد کاربر جدید فرم زیر را تکمیل کنید.
            </p>
          </div>
          <btn isMini='true' label='به‌روز رسانی' bc='#667089'
            style="margin: 8px !important;"
            v-if="false"
            icon='keyboard_arrow_left' @click.native="backToCourse"/>
        </div>
        <div class="tabHeader fRow jStart aCenter fullWidth" id="tab"
          style="margin-bottom: 16px">
          <a @click="toggleSection('new')"
            class="tabBtn fRow jCenter aCenter
            w25 transition-fast" v-bind:class="{selected: isNewUser}">
            <i class="material-icons-round transition-fast">reorder</i>
            <span class="transition-fast">کاربر جدید</span>
          </a>
          <a @click="toggleSection('manage')"
            class="tabBtn fRow jCenter aCenter
            w25 transition-fast" v-bind:class="{selected: isManageUser}">
            <i class="material-icons-round transition-fast">reorder</i>
            <span class="transition-fast">مدیریت کاربر‌ها</span>
          </a>
        </div>
        <!-- صفحه اضافه کردن کاربر جدید -->
        <div class="uploadersHolder fRow jBetween aCenter wrap fullWidth"
          v-if='isNewUser'>
          <div class="fRow jBetween aStart fullWidth assignmentForm">
            <!-- فرم عمومی -->
            <div class="w60 fRow jBetween aCenter wrap formSection">
              <div class="rulesMini fullWidth fRow jStart aCenter">
                <i class="material-icons-round">looks_one</i>
                <div class="fCol jCenter aStart growFull">
                  <label>فرم اطلاعات عمومی</label>
                  <span>برای ایجاد کاربر جدید فرم زیر را تکمیل کنید</span>
                </div>
              </div>
              <div class="fRow jStart aCenter fullWidth">
                <!-- تصویر کاربر -->
                <div class="inputWrapper fCol aCenter jStart">
                  <div class="top-row fRow jStart aCenter">
                    <p>آواتار کاربر را آپلود کنید</p>
                  </div>
                  <get-photo
                    w='100%'
                    style="margin-top: -8px"
                    v-on:photoupload="getUploaded"
                    photoFor='teacher'
                    :initImg='this.computedInitImage'
                    uploadMsg='آپلود تصویر الزامیست'
                    uploadLabel='تصویر دبیر'/>
                </div>
                <div class="fRow jStart aCenter growFull wrap" style="margin-right: 16px">
                  <!-- انتخاب نوع کاربر -->
                  <div class="w60 fCol jStart aStart inputHolder">
                    <span class="fRow jStart aCenter">
                      <i class="material-icons-round"
                        v-bind:class="{inpErr: userTypeErr}">keyboard_double_arrow_down</i>
                      نوع کاربر</span>
                      <cool-select
                        class="fullWidth"
                        @select="selected($event, 'userType')"
                        disable-search
                        v-model="userType"
                        :items="userTypes"
                        :item-value="userTypes.id"
                        :item-text="userTypes.title">
                        <!-- slot for each item in the menu -->
                        <template slot="item" slot-scope="{ item: userTypes }">
                          <div style="display: flex; align-items: center;">
                            <div>
                              {{ userTypes.title }}
                            </div>
                          </div>
                        </template>
                        <!-- slot for the selected item (in the text field) -->
                        <template slot="selection" slot-scope="{ item: userTypes }">
                          <div>
                            {{ userTypes.title }}
                          </div>
                        </template>
                      </cool-select>
                  </div>
                  <!-- وضعیت کاربر -->
                  <div class="w40 fCol jStart aStart inputHolder"
                    style="margin-right: 16px"
                    @click="userStatus = !userStatus">
                    <span class="fRow jStart aCenter">
                      <i class="material-icons-round">radio_button_checked</i>
                      وضعیت کاربر</span>
                    <switch-button
                      :val='userStatus'
                      style="margin: 12px 0"
                      activeLabel='فعال'
                      deactiveLabel='غیرفعال'/>
                  </div>
                  <!-- نام کاربر -->
                  <div class="fCol jStart aStart inputHolder fullWidth">
                    <span class="fRow jStart aCenter"
                      v-bind:class="{inpErr: nameErr}">
                      <i class="material-icons-round">person</i>
                      نام کاربر {{name.length}}/24</span>
                    <div class="fRow jStart aCenter fullWidth inputWraper">
                      <input class="transition-fast" placeholder="نام کاربر"
                        type="text" v-model="name">
                    </div>
                  </div>
                  <!-- نام خانوادگی کاربر -->
                  <div class="fCol jStart aStart inputHolder fullWidth">
                    <span class="fRow jStart aCenter"
                      v-bind:class="{inpErr: lastNameErr}">
                      <i class="material-icons-round">person</i>
                      نام خانوادگی کاربر {{lastName.length}}/24</span>
                    <div class="fRow jStart aCenter fullWidth inputWraper">
                      <input class="transition-fast" placeholder="نام خانوادگی کاربر"
                        type="text" v-model="lastName">
                    </div>
                  </div>
                </div>
              </div>
              <!-- نام کاربری -->
              <div class="w50 fCol jStart aStart inputHolder">
                <span class="fRow jStart aCenter">
                  <i class="material-icons-round"
                    v-bind:class="{inpErr: usernameErr}">alternate_email</i>
                  شناسۀ کاربری - {{username.length}}/12</span>
                <div class="fRow jStart aCenter fullWidth inputWraper">
                  <input class="transition-fast" placeholder="شناسۀ کاربری"
                    :disabled="usernameAuto"
                    style="font-family: Tahoma; padding: 10px 10px !important;"
                    type="text" v-model="username">
                  <div class="b fab fRow jCenter aCenter active"
                    title="ایجاد شناسۀ کاربری اتوماتیک"
                    style="margin-right: 8px"
                    @click="randomUserName">
                    <i class="material-icons-round">alternate_email</i>
                  </div>
                  <div class="b fab fRow jCenter aCenter"
                    title="ویرایش نام کاربری"
                    style="margin-right: 8px"
                    @click="usernameAuto = !usernameAuto">
                    <i class="material-icons-round">edit</i>
                  </div>
                </div>
              </div>
              <!-- پسورد -->
              <div class="w50 fCol jStart aStart inputHolder">
                <span class="fRow jStart aCenter">
                  <i class="material-icons-round"
                    v-bind:class="{inpErr: userPasswordErr}">password</i>
                  رمز عبور - {{userPassword.length}}/12</span>
                <div class="fRow jStart aCenter fullWidth inputWraper">
                  <input class="transition-fast" placeholder="رمز عبور"
                    :disabled="userPasswordAuto"
                    style="font-family: Tahoma; padding: 10px 10px !important;"
                    type="text" v-model="userPassword">
                  <div class="b fab fRow jCenter aCenter active"
                    title="ایجاد رمز عبور اتوماتیک"
                    style="margin-right: 8px"
                    @click="makePassWord">
                    <i class="material-icons-round">password</i>
                  </div>
                  <div class="b fab fRow jCenter aCenter"
                    title="ویرایش پسورد"
                    style="margin-right: 8px"
                    @click="userPasswordAuto = !userPasswordAuto">
                    <i class="material-icons-round">edit</i>
                  </div>
                </div>
              </div>
              <!-- شماره همراه -->
              <div class="w50 fCol jStart aStart inputHolder">
                <span class="fRow jStart aCenter">
                  <i class="material-icons-round"
                    v-bind:class="{inpErr: userPhoneErr}">phone_iphone</i>
                  شماره همراه - {{userPhone.length}}/11</span>
                <div class="fRow jStart aCenter fullWidth inputWraper">
                  <input @keyup.enter="newAssignment"
                    class="transition-fast" placeholder="شماره همراه"
                    type="number" v-model="userPhone">
                </div>
              </div>
              <!-- کد ملی -->
              <div class="w50 fCol jStart aStart inputHolder">
                <span class="fRow jStart aCenter">
                  <i class="material-icons-round"
                    v-bind:class="{inpErr: melliErr}">fingerprint</i>
                  کد ملی - {{melli.length}}/10</span>
                <div class="fRow jStart aCenter fullWidth inputWraper">
                  <input @keyup.enter="newAssignment"
                    class="transition-fast" placeholder="کد ملی"
                    type="number" v-model="melli">
                </div>
              </div>
              <div class="backups" v-if="false">
                <!-- تاریخ و ساعت برگزاری -->
                <div class="w60 fCol jStart aStart inputHolder">
                  <span class="fRow jStart aCenter">
                    <i class="material-icons-round"
                      v-bind:class="{inpErr: classDateErr}">date_range</i>
                    تاریخ و ساعت شروع کلاس</span>
                  <div class="fRow jStart aCenter fullWidth inputWraper">
                    <input @keyup.enter="newAssignment" id="classDate"
                      disabled
                      class="transition-fast" placeholder="تاریخ و ساعت"
                      type="text" v-model="classDateShow">
                  </div>
                </div>
                <!-- مدت زمان کلاس -->
                <div class="fCol jStart aStart inputHolder w40" >
                  <span class="fRow jStart aCenter"
                    v-bind:class="{inpErr: classDurationErr}">
                    <i class="material-icons-round">timer</i>
                    مدت زمان کلاس‌ (دقیقه)</span>
                  <div class="fRow jStart aCenter fullWidth inputWraper">
                    <input @keyup.enter="newAssignment"
                      class="transition-fast" placeholder="مدت به دقیقه"
                      type="number" v-model="classDuration">
                  </div>
                </div>
                <!-- انتخاب رشته -->
                <div class="fullWidth fCol jStart aStart inputHolder">
                  <span class="fRow jStart aCenter">
                    <i class="material-icons-round"
                      v-bind:class="{inpErr: classFieldErr}">biotech</i>
                    انتخاب رشته</span>
                    <cool-select
                      class="fullWidth"
                      @select="selected($event, 'classField')"
                      disable-search
                      v-model="classField"
                      :items="classFields"
                      :item-value="classFields.id"
                      :item-text="classGrades.title">
                      <!-- slot for each item in the menu -->
                      <template slot="item" slot-scope="{ item: classFields }">
                        <div style="display: flex; align-items: center;">
                          <div>
                            {{ classFields.title }}
                          </div>
                        </div>
                      </template>
                      <!-- slot for the selected item (in the text field) -->
                      <template slot="selection" slot-scope="{ item: classFields }">
                        <div>
                          {{ classFields.title }}
                        </div>
                      </template>
                    </cool-select>
                </div>
                <!-- انتخاب پایه -->
                <div class="fullWidth fCol jStart aStart inputHolder">
                  <span class="fRow jStart aCenter">
                    <i class="material-icons-round"
                      v-bind:class="{inpErr: classGradeErr}">clear_all</i>
                    انتخاب پایه</span>
                    <cool-select
                      class="fullWidth"
                      @select="selected($event, 'classGrade')"
                      disable-search
                      v-model="classGrade"
                      :items="classGrades"
                      :item-value="classGrades.id"
                      :item-text="classGrades.title">
                      <!-- slot for each item in the menu -->
                      <template slot="item" slot-scope="{ item: classGrades }">
                        <div style="display: flex; align-items: center;">
                          <div>
                            {{ classGrades.title }}
                          </div>
                        </div>
                      </template>
                      <!-- slot for the selected item (in the text field) -->
                      <template slot="selection" slot-scope="{ item: classGrades }">
                        <div>
                          {{ classGrades.title }}
                        </div>
                      </template>
                    </cool-select>
                </div>
                <!-- انتخاب درس -->
                <div class="fullWidth fCol jStart aStart inputHolder">
                  <span class="fRow jStart aCenter">
                    <i class="material-icons-round"
                      v-bind:class="{inpErr: classLessonErr}">school</i>
                    انتخاب درس</span>
                    <cool-select
                      class="fullWidth"
                      @select="selected($event, 'classLesson')"
                      disable-search
                      v-model="classLesson"
                      :items="classLessons"
                      :item-value="classLessons.id"
                      :item-text="classGrades.title">
                      <!-- slot for each item in the menu -->
                      <template slot="item" slot-scope="{ item: classLessons }">
                        <div style="display: flex; align-items: center;">
                          <div>
                            {{ classLessons.title }}
                          </div>
                        </div>
                      </template>
                      <!-- slot for the selected item (in the text field) -->
                      <template slot="selection" slot-scope="{ item: classLessons }">
                        <div>
                          {{ classLessons.title }}
                        </div>
                      </template>
                    </cool-select>
                </div>
                <!-- انتخاب استاد -->
                <div class="fullWidth fCol jStart aStart inputHolder">
                  <span class="fRow jStart aCenter" style="margin-bottom: 8px">
                    <i class="material-icons-round"
                      v-bind:class="{inpErr: classLessonErr}">school</i>
                    انتخاب استاد</span>
                  <div class="fullWidth fRow jBetween aStart wrap teachers">
                    <div class="fRow jStart aCenter w50 teachersResult">
                      <div class="ava"></div>
                      <div class="fCol jCenter aStart stInfo growFull">
                        <div class="stName">مهدی کاظمی</div>
                        <div class="stPhone">09305943207</div>
                      </div>
                    </div>
                    <div class="fRow jStart aCenter w50 teachersResult selected">
                      <div class="ava"></div>
                      <div class="fCol jCenter aStart stInfo growFull">
                        <div class="stName">مهدی کاظمی</div>
                        <div class="stPhone">09305943207</div>
                      </div>
                    </div>
                    <div class="fRow jStart aCenter w50 teachersResult">
                      <div class="ava"></div>
                      <div class="fCol jCenter aStart stInfo growFull">
                        <div class="stName">مهدی کاظمی</div>
                        <div class="stPhone">09305943207</div>
                      </div>
                    </div>
                    <div class="noRes fCol jCenter aCenter fullWidth">
                      <i class="material-icons-round">cancel</i>
                      <span>استاد یافت نشد</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="fRow jStart aCenter fullWidth">
                <div class="b fRow jStart aCenter big"
                  v-bind:class="{active: isFormReady}">
                  <i class="material-icons-round">done_all</i>
                  <label>ثبت کلاس جدید</label>
                </div>
                <div class="b fRow jStart aCenter mini" @click="clearNewClassForm">
                  <i class="material-icons-round">delete</i>
                  <label>پاک کردن فرم</label>
                </div>
              </div>
            </div>
            <!-- فرم اختصاصی -->
            <div class="w40 fRow jBetween aCenter wrap formSection">
              <div class="rulesMini fullWidth fRow jStart aCenter">
                <i class="material-icons-round">looks_two</i>
                <div class="fCol jCenter aStart growFull">
                  <label>فرم اختصاصی {{userType.title}}</label>
                  <span>کلاس مورد نظر را جستجو کنید و عملیات مورد نظر را انجام دهید</span>
                </div>
              </div>
              <!-- فرم ادمین سایت -->
              <div class="fCol jStart aStart fullWidth" v-if="userType.id === 1">
                فرم {{userType.title}}
              </div>
              <!-- فرم دانش آموز -->
              <div class="fCol jStart aStart fullWidth" v-if="userType.id === 2">
                فرم {{userType.title}}
              </div>
              <!-- فرم استاد -->
              <div class="fCol jStart aStart fullWidth" v-if="userType.id === 3">
                فرم {{userType.title}}
              </div>
              <!-- فرم مشاور -->
              <div class="fCol jStart aStart fullWidth" v-if="userType.id === 4">
                فرم {{userType.title}}
              </div>
              <!-- manage backups -->
              <div id="manageBackups" v-if="false">
                <div class="fRow jBetween aCenter fullWidth wrap" style="margin: 0 0 16px 0">
                  <!-- نام کاربر -->
                  <div class="fCol jStart aStart inputHolder w50">
                    <span class="fRow jStart aCenter">
                      <i class="material-icons-round">title</i>
                      نام کاربر</span>
                    <div class="fRow jStart aCenter fullWidth inputWraper">
                      <input class="transition-fast" placeholder="نام کاربر"
                        v-model="classSearch"
                        type="text">
                    </div>
                  </div>
                  <div class="fCol jStart aStart inputHolder w50">
                    <span class="fRow jStart aCenter">
                      <i class="material-icons-round">title</i>
                      بازه زمانی</span>
                    <div class="fRow jStart aCenter fullWidth inputWraper">
                      <input class="transition-fast" placeholder="نام کاربر"
                        id="classRange"
                        v-model="classRangeShow"
                        type="text">
                    </div>
                  </div>
                  <vpdp v-model="classRange" range element="classRange"/>
                  <!-- انتخاب رشته -->
                  <div class="w33 fCol jStart aStart inputHolder">
                    <span class="fRow jStart aCenter">
                      <i class="material-icons-round"
                        v-bind:class="{inpErr: classFieldErr}">biotech</i>
                      انتخاب رشته</span>
                      <cool-select
                        class="fullWidth"
                        @select="selected($event, 'classField')"
                        disable-search
                        v-model="classField"
                        :items="classFields"
                        :item-value="classFields.id"
                        :item-text="classGrades.title">
                        <!-- slot for each item in the menu -->
                        <template slot="item" slot-scope="{ item: classFields }">
                          <div style="display: flex; align-items: center;">
                            <div>
                              {{ classFields.title }}
                            </div>
                          </div>
                        </template>
                        <!-- slot for the selected item (in the text field) -->
                        <template slot="selection" slot-scope="{ item: classFields }">
                          <div>
                            {{ classFields.title }}
                          </div>
                        </template>
                      </cool-select>
                  </div>
                  <!-- انتخاب پایه -->
                  <div class="w33 fCol jStart aStart inputHolder">
                    <span class="fRow jStart aCenter">
                      <i class="material-icons-round"
                        v-bind:class="{inpErr: classGradeErr}">clear_all</i>
                      انتخاب پایه</span>
                      <cool-select
                        class="fullWidth"
                        @select="selected($event, 'classGrade')"
                        disable-search
                        v-model="classGrade"
                        :items="classGrades"
                        :item-value="classGrades.id"
                        :item-text="classGrades.title">
                        <!-- slot for each item in the menu -->
                        <template slot="item" slot-scope="{ item: classGrades }">
                          <div style="display: flex; align-items: center;">
                            <div>
                              {{ classGrades.title }}
                            </div>
                          </div>
                        </template>
                        <!-- slot for the selected item (in the text field) -->
                        <template slot="selection" slot-scope="{ item: classGrades }">
                          <div>
                            {{ classGrades.title }}
                          </div>
                        </template>
                      </cool-select>
                  </div>
                  <!-- انتخاب درس -->
                  <div class="w33 fCol jStart aStart inputHolder">
                    <span class="fRow jStart aCenter">
                      <i class="material-icons-round"
                        v-bind:class="{inpErr: classLessonErr}">school</i>
                      انتخاب درس</span>
                      <cool-select
                        class="fullWidth"
                        @select="selected($event, 'classLesson')"
                        disable-search
                        v-model="classLesson"
                        :items="classLessons"
                        :item-value="classLessons.id"
                        :item-text="classGrades.title">
                        <!-- slot for each item in the menu -->
                        <template slot="item" slot-scope="{ item: classLessons }">
                          <div style="display: flex; align-items: center;">
                            <div>
                              {{ classLessons.title }}
                            </div>
                          </div>
                        </template>
                        <!-- slot for the selected item (in the text field) -->
                        <template slot="selection" slot-scope="{ item: classLessons }">
                          <div>
                            {{ classLessons.title }}
                          </div>
                        </template>
                      </cool-select>
                  </div>
                  <div class="b fRow jStart aCenter" style="margin-right: 8px">
                    <i class="material-icons-round">search</i>
                    <label>جستجو</label>
                  </div>
                  <div class="b fRow jStart aCenter active" style="width: 140px">
                    <i class="material-icons-round">repeat</i>
                    <label>بارگیری دوباره</label>
                  </div>
                </div>
                <div class="classList fCol jStart aStart fullWidth">
                  <div class="classItem fRow jStart aCenter fullWidth">
                    <div class="classIndex">1</div>
                    <div class="fCol growFull jCenter aStart">
                      <div class="className">ادبیات فارسی و معنی شعر</div>
                      <div class="classTeacher">استاد ابراهیم زاده</div>
                    </div>
                    <div class="classActions fRow jCenter aCenter">
                      <i class="action material-icons-round" :title="item.tooltip"
                        @click="doClassAction(item.type)"
                        v-for="(item, index) in classOptions" v-bind:key="index">{{item.icon}}</i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- صفحه انتخاب دانش آموزان -->
        <div class="uploadersHolder fRow jBetween aCenter wrap fullWidth"
          v-if='isNewUser'>
          <!-- loading -->
          <div class="fCol jCenter aCenter fullWidth"
            v-if="false">
            <!-- v-if="loading || noContent"> -->
            <p-bar
              :loading="loading"
              :notYet="notYet"
              :noContent="noContent"
              :notFound="notFound"
              :error="error" />
          </div>
          <!-- pagination -->
          <div class="fRow jStart aCenter fullWidth" v-if="loaded">
            <pagination :active='activePage' :psize='pageSize'
              @resetPageSize="resetPageSize($event)"
              :pages='howManyPages' @goToPage="GoToPages($event)" />
          </div>
        </div>
      </card>
    </dashboard-page>
    <tool-bar/>
    <right-menu/>
    <modal v-if="modalShow">
      <card w="580px">
        <label class="question">با ترک این صفحه آپلودها متوقف می‌شوند.
          آیا مایل به ترک این صفحه هستید؟</label>
        <div class="fullWidth wrap aStart jStart fRow btnRow">
          <btn label="نمایش لیست ویدئوها" btnWidth='236px' bc='#ff0533'
          icon="delete_sweep" @click.native="showListAnyWay"/>
          <keep-alive>
            <btn fabBtn='true' label="بازگشت" btnWidth='auto'
              @click.native="closeModal" bc='#aaaaaa' icon="close"/>
          </keep-alive>
        </div>
      </card>
    </modal>
  </div>
</template>

<script>
import axios from 'axios';
import RightMenu from '@/components/RightMenu.vue';
import ToolBar from '@/components/ToolBar.vue';
import DashboardPage from '@/components/DashboardPage.vue';
import Card from '@/components/Card.vue';
import Btn from '@/components/Btn.vue';
import errorHandler from '@/mixins/mixin';
import makeToast from '@/mixins/makeToast';
import SwitchButton from '@/components/SwitchButton.vue';
import Toast from '@/components/Toast.vue';
import ticks from '@/mixins/ticks';
import Modal from '@/components/Modal.vue';
import { CoolSelect } from 'vue-cool-select';
import moment from 'moment-jalaali';
import Pagination from '@/components/Pagination.vue';
import pBar from '@/components/pBar.vue';
import 'vue-cool-select/dist/themes/material-design-dark.scss';
import '@/assets/new.scss';
import Vpdp from 'vue-persian-datetime-picker';
import GetPhoto from '@/components/GetPhoto.vue';

export default {
  mixins: [errorHandler, makeToast, ticks],
  data() {
    return {
      baseURL: this.$store.state.baseUrl,
      V: this.$store.state.apiVersion,
      // modes ↓
      loading: false,
      noContent: false,
      notFound: false,
      error: false,
      notYet: false,
      loaded: true,
      modeMsg: '',
      // modes ↑
      isNewUser: true,
      isManageUser: false,
      isExamList: false,
      isBank: true,
      startDate: '',
      startDateShow: '',
      stErr: true,
      endDate: '',
      endDateShow: '',
      etErr: true,
      notPayed: false,
      payDate: '',
      payDateShow: '',
      payDateErr: true,
      payAmount: '',
      payAmountErr: true,
      questionBank: [
        {
          id: 0,
          title: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ؟',
          img: '',
          level: 'easy',
        },
        {
          id: 1,
          title: 'کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد؟',
          img: 'https://api.rimik.ir/photo/4bb8eb17-2413-4497-9093-44f1ca691b79.jpg',
          level: 'hard',
        },
        {
          id: 2,
          title: 'کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد ؟',
          img: '',
          level: 'hard',
        },
        {
          id: 3,
          title: 'تمام و دشواری موجود در ارائه؟',
          img: '',
          level: 'normal',
        },
        {
          id: 4,
          title: 'شرایط سخت تایپ به پایان رسد و زمان مورد نیاز شامل حروفچینی دستاوردهای اصلی؟',
          img: '',
          level: 'hard',
        },
        {
          id: 5,
          title: 'جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد؟',
          img: '',
          level: 'easy',
        },
      ],
      // simple example of items
      field: '',
      fieldErr: true,
      plans: [
        {
          id: 0,
          title: 'رشته را انتخاب کنید',
        },
      ],
      plan: '',
      planErr: true,
      conventions: [
        {
          id: 0,
          title: 'لیست مشاور از وب سرویس',
        },
      ],
      convention: '',
      conventionErr: true,
      // there will be a selected item
      fieldSelected: '',
      // اطلاعات مشترک همه کاربران
      modalShow: false,
      name: '',
      nameErr: true,
      lastName: '',
      lastNameErr: true,
      userTypes: [
        {
          id: 1,
          title: 'ادمین سایت',
        },
        {
          id: 2,
          title: 'دانش آموز',
        },
        {
          id: 3,
          title: 'استاد',
        },
        {
          id: 4,
          title: 'مشاور',
        },
      ],
      userType: '',
      userTypeErr: true,
      username: '',
      usernameErr: false,
      usernameAuto: true,
      userPassword: '',
      userPasswordErr: false,
      userPasswordAuto: true,
      userAvatar: '',
      // parents ↓
      father: '',
      fatherErr: true,
      fatherJob: '',
      fatherJobErr: true,
      fatherEdu: '',
      fatherEduErr: true,
      fatherPhone: '',
      fatherPhoneErr: true,
      mother: '',
      motherErr: true,
      motherJob: '',
      motherJobErr: true,
      motherEdu: '',
      motherEduErr: true,
      motherPhone: '',
      motherPhoneErr: true,
      // parents ↑
      melli: '',
      melliErr: true,
      userPhone: '',
      userPhoneErr: true,
      // convention form
      conventionName: '',
      adNameErr: true,
      conventionFamily: '',
      adFamilyErr: true,
      conventionPhone: 0,
      adPhoneErr: true,
      conventionsData: [],
      // pagination
      howManyPages: 0,
      pageSize: 10,
      activePage: 1,
      // اطلاعات دانش آموزان
      studentsList: [],
      sSearch: '',
      studentData: {
        firstName: 'مهدی',
        lastName: 'کاظمی',
      },
      // moasese
      company: [
        {
          name: 'ریمیک',
          icon: 'rimik',
          id: 0,
        },
        {
          name: 'هدف سازان',
          icon: 'rimik',
          id: 1,
        },
        {
          name: 'ورتــــا',
          icon: 'rimik',
          id: 2,
        },
        {
          name: 'دکتر بشیرپور',
          icon: 'rimik',
          id: 2,
        },
      ],
      selectedCompany: -1,
      // accounting
      payments: [],
      paymentLoad: false,
      // class
      classTitle: '',
      classTitleErr: true,
      classDesc: '',
      classDescErr: true,
      classDuration: 60,
      classDurationErr: false,
      classServers: [
        {
          id: 1,
          title: 'Big Blue Button',
        },
        {
          id: 2,
          title: 'Adobe Connect',
        },
      ],
      classServer: '',
      classServerErr: true,
      classGrades: [
        {
          id: 1,
          title: 'پایه اول',
        },
        {
          id: 2,
          title: 'Adobe Connect',
        },
      ],
      classGrade: '',
      classGradeErr: true,
      classFields: [
        {
          id: 0,
          title: 'متوسطه‌ی اول',
        },
        {
          id: 1,
          title: 'ریاضی',
        },
        {
          id: 2,
          title: 'تجربی',
        },
        {
          id: 3,
          title: 'انسانی',
        },
        {
          id: 4,
          title: 'فنی',
        },
        {
          id: 5,
          title: 'زبان',
        },
        {
          id: 6,
          title: 'هنر',
        },
      ],
      classField: '',
      classFieldErr: true,
      classLessons: [
        {
          id: 1,
          title: 'فارسی',
        },
        {
          id: 2,
          title: 'علوم',
        },
      ],
      classLesson: '',
      classLessonErr: true,
      classDate: '',
      classDateShow: '',
      classDateErr: true,
      classOptions: [
        {
          type: 'deleteMeeting',
          icon: 'delete',
          tooltip: 'حذف کلاس',
        },
        {
          type: 'join',
          icon: 'login',
          tooltip: 'ورود به کلاس',
        },
        {
          type: 'edit',
          icon: 'edit',
          tooltip: 'ویرایش کلاس',
        },
        {
          type: 'copyLinkHost',
          icon: 'content_copy',
          tooltip: 'کپی لینک برای میزبان',
        },
        {
          type: 'recorded',
          icon: 'play_arrow',
          tooltip: 'مشاهده‌ی ویدیو',
        },
      ],
      userStatus: false,
      // manage class
      classRange: '',
      classRangeShow: '',
      classRangeErr: true,
      classSearch: '',
      isTyping: false,
      isTypingInterval: null,
      sec: 0,
    };
  },
  methods: {
    setMode(m, msg) {
      this.noContent = false;
      this.loading = false;
      this.notYet = false;
      this.error = false;
      this.loaded = false;
      this.modeMsg = '';
      switch (m) {
        case 'loading': {
          this.loading = true;
          break;
        }
        case 'loaded': {
          this.loaded = true;
          break;
        }
        case 'error': {
          this.modeMsg = msg;
          this.error = true;
          break;
        }
        case 'notYet': {
          this.notYet = true;
          break;
        }
        case 'noContent': {
          this.noContent = true;
          break;
        }
        default:
          break;
      }
    },
    backToCourse() {
      this.$store.commit('resetCourseObject');
      this.$router.push('/courses');
    },
    getTeacherPhoto() {
      const reqUrl = `${this.baseURL}/api/v${this.V}/Teachers/${this.teacherId}`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        this.posts = response.data;
        if (this.posts.isSuccess) {
          // console.log(this.posts);
          this.teacherImg = this.posts.data.user.avatar;
        } else {
          this.responseFalse = true;
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
      });
    },
    addNewUploader() {
      // alert(event);
      this.isVideoUploading = true;
      this.uploaderCount += 1;
      this.uploaderArray.push(this.uploaderCount.toString());
    },
    closeModal() {
      this.modalShow = false;
    },
    showListAnyWay() {
      this.isVideoUploading = false;
      this.modalShow = false;
      this.toggleSection('list');
    },
    toggleSection(order) {
      this.isNewUser = false;
      this.isManageUser = false;
      switch (order) {
        case 'new': {
          this.isNewUser = true;
          break;
        }
        case 'manage': {
          this.isManageUser = true;
          break;
        }
        default:
          break;
      }
    },
    selected(e, dropDown) {
      switch (dropDown) {
        case 'userType': {
          // const a = this.userType.id;
          // this.randomUserName();
          break;
        }
        default:
          break;
      }
    },
    commaSep(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    GoToPages(event) {
      if (event === 'next') {
        // alert('next');
        this.activePage += 1;
        if (this.activePage > this.howManyPages) {
          this.activePage = 1;
        }
        this.getStudents(this.activePage);
        return;
      }
      if (event === 'prev') {
        this.activePage -= 1;
        if (this.activePage < 1) {
          this.activePage = this.howManyPages;
        }
        this.getStudents(this.activePage);
        return;
      }
      this.getStudents(event);
      this.activePage = event;
    },
    // class get grade
    sayFieldName(num) {
      let sfn = '';
      switch (num) {
        case 0: {
          sfn = 'متوسطه‌ی اول';
          break;
        }
        case 1: {
          sfn = 'ریاضی فیزیک';
          break;
        }
        case 2: {
          sfn = 'علوم تجربی';
          break;
        }
        case 3: {
          sfn = 'انسانی';
          break;
        }
        case 4: {
          sfn = 'فنی';
          break;
        }
        case 5: {
          sfn = 'هنر';
          break;
        }
        case 6: {
          sfn = 'زبان';
          break;
        }
        default:
          break;
      }
      return sfn;
    },
    doClassAction() {
      // console.log(a);
    },
    newStudent() {
      if (this.isFormReady) {
        const reqUrl = `${this.baseURL}/api/v${this.V}/Users/student`;
        axios({
          method: 'post',
          url: reqUrl,
          headers: {
            Authorization: this.$authObeject.authToken(),
          },
          data: {
            firstName: this.name,
            lastName: this.lastName,
            phoneNumber: this.userPhone.replace('09', '989'),
            fatherName: this.father,
            nationalCode: this.melli,
            planType: this.plan.title,
            startTheContract: this.startDate,
            endTheContract: this.endDate,
            field: this.field.id,
            consultantId: this.convention.id,
            paymentType: this.notPayed ? null : this.classServer.title,
            paymentAmount: this.notPayed ? null : this.payAmount.replace(/,/g, ''),
            paymentDate: this.notPayed ? '0001-01-01T00:00:00' : this.payDate,
            paymentDescription: this.notPayed ? null : this.payDesc,
          },
        }).then((response) => {
          if (response.data.isSuccess) {
            this.getConventions();
            this.makeToast('success', 'تفاهم‌نامه‌ی جدید با موفقیت ثبت شد', 3000);
            this.clearNewClassForm();
          } else {
            this.makeToast('error', response.data.message, 3000);
          }
        }, (error) => {
          this.makeToast('error', `${this.errorHandler(error)}. درستی شماره را بررسی نمایید`, 3000);
          // console.log(error);
        }).catch(() => {
          this.makeToast('error', 'در صورت درستی اتصال به اینترنت، با تیم فنی تماس بگیرید', 3000);
        });
      } else {
        this.makeToast('error', 'ابتدا فرم را تکمیل کنید', 3000);
      }
    },
    clearNewClassForm() {
      this.classTitle = '';
      this.classDesc = '';
      this.classDate = '';
      this.classServer = '';
      this.classServerErr = true;
      this.classGrade = '';
      this.classGradeErr = true;
      this.classField = '';
      this.classFieldErr = true;
      this.classLesson = '';
      this.classLessonErr = true;
    },
    // getPayments
    getPayment() {
      this.paymentLoad = false;
      const reqUrl = `${this.baseURL}/api/v${this.V}/Payments/${this.data.userId}`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        this.paymentLoad = true;
        if (response.data.isSuccess) {
          this.payments = response.data.data;
        } else {
          this.makeToast('error', response.data.message, 3000);
        }
      }, (error) => {
        this.paymentLoad = true;
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      }).catch(() => {
        this.paymentLoad = false;
        this.makeToast('error', 'در صورت درستی اتصال به اینترنت، با تیم فنی تماس بگیرید', 3000);
      });
    },
    // random user name
    randomUserName() {
      const b = Math.floor(Math.random() * 9999999) + 1000000;
      const a = Math.floor(Math.random() * 9999999) + 1000000;
      const c = ((a + b) / 2).toFixed(0);
      const i = this.userType;
      let un = '';
      if (i === '' || i.length === 0) {
        un += `user${c}`;
      } else {
        switch (i.id) {
          case 1: {
            un += 'admin';
            break;
          }
          case 2: {
            un += 'student';
            break;
          }
          case 3: {
            un += 'teacher';
            break;
          }
          case 4: {
            un += 'adviser';
            break;
          }
          default: {
            un += 'user';
            break;
          }
        }
        un += c;
      }
      this.username = un;
    },
    makePassWord() {
      let pass = '';
      let rand = 0;
      rand = Math.floor(Math.random() * (90 - 65)) + 65;
      pass += String.fromCharCode(rand);
      rand = Math.floor(Math.random() * (90 - 65)) + 65;
      pass += String.fromCharCode(rand);
      rand = Math.floor(Math.random() * (57 - 48)) + 48;
      pass += String.fromCharCode(rand);
      rand = Math.floor(Math.random() * (57 - 48)) + 48;
      pass += String.fromCharCode(rand);
      rand = Math.floor(Math.random() * (57 - 48)) + 48;
      pass += String.fromCharCode(rand);
      rand = Math.floor(Math.random() * (57 - 48)) + 48;
      pass += String.fromCharCode(rand);
      rand = Math.floor(Math.random() * (122 - 97)) + 97;
      pass += String.fromCharCode(rand);
      rand = Math.floor(Math.random() * (122 - 97)) + 97;
      pass += String.fromCharCode(rand);
      this.userPassword = pass;
      // alert(pass);
    },
    getUploaded(event) {
      this.tAvatar = event;
    },
  },
  components: {
    RightMenu,
    ToolBar,
    DashboardPage,
    Card,
    Btn,
    Toast,
    Modal,
    CoolSelect,
    Pagination,
    pBar,
    Vpdp,
    SwitchButton,
    GetPhoto,
  },
  watch: {
    fieldSelected() {
    },
    name() {
      if (this.name.length <= 2) {
        this.nameErr = true;
      } else if (this.name.length > 24) {
        this.name = this.name.substr(0, 24);
        this.nameErr = false;
      } else {
        this.nameErr = false;
      }
    },
    lastName() {
      if (this.lastName.length <= 2) {
        this.lastNameErr = true;
      } else if (this.lastName.length > 24) {
        this.lastName = this.lastName.substr(0, 24);
        this.lastNameErr = false;
      } else {
        this.lastNameErr = false;
      }
    },
    userType() {
      if (this.userType === '' || this.userType.length === 0) {
        this.userTypeErr = true;
      } else {
        this.userTypeErr = false;
      }
      this.randomUserName();
      this.makePassWord();
    },
    userPhone() {
      const phonePattern = /^\(?([0-9]{4})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
      if (this.userPhone.length > 11) {
        this.userPhone = this.userPhone.substr(0, 11);
        // console.log(this.message);
        this.userPhoneErr = false;
      }
      if (this.userPhone.match(phonePattern)
        && this.userPhone.charAt(0) === '0'
        && this.userPhone.charAt(1) === '9') {
        this.userPhoneErr = false;
      } else {
        this.userPhoneErr = true;
      }
    },
    username() {
      if (this.username.length <= 5) {
        this.usernameErr = true;
      } else if (this.username.length > 12) {
        this.username = this.username.substr(0, 12);
        this.usernameErr = false;
      } else {
        this.usernameErr = false;
      }
    },
    father() {
      if (this.father.length === 0) {
        this.fatherErr = true;
      } else if (this.father.length > 40) {
        this.father = this.father.substr(0, 40);
        this.fatherErr = false;
      } else {
        this.fatherErr = false;
      }
    },
    fatherJob() {
      if (this.fatherJob.length === 0) {
        this.fatherJobErr = true;
      } else if (this.fatherJob.length > 40) {
        this.fatherJob = this.fatherJob.substr(0, 40);
        this.fatherJobErr = false;
      } else {
        this.fatherJobErr = false;
      }
    },
    fatherEdu() {
      if (this.fatherEdu.length === 0) {
        this.fatherEduErr = true;
      } else if (this.fatherEdu.length > 40) {
        this.fatherEdu = this.fatherEdu.substr(0, 40);
        this.fatherEduErr = false;
      } else {
        this.fatherEduErr = false;
      }
    },
    fatherPhone() {
      const phonePattern = /^\(?([0-9]{4})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
      if (this.fatherPhone.length > 11) {
        this.fatherPhone = this.fatherPhone.substr(0, 11);
        // console.log(this.message);
        this.fatherPhoneErr = false;
      }
      if (this.fatherPhone.match(phonePattern)
        && this.fatherPhone.charAt(0) === '0'
        && this.fatherPhone.charAt(1) === '9') {
        this.fatherPhoneErr = false;
      } else {
        this.fatherPhoneErr = true;
      }
    },
    mother() {
      if (this.mother.length === 0) {
        this.motherErr = true;
      } else if (this.mother.length > 40) {
        this.mother = this.mother.substr(0, 40);
        this.motherErr = false;
      } else {
        this.motherErr = false;
      }
    },
    motherJob() {
      if (this.motherJob.length === 0) {
        this.motherJobErr = true;
      } else if (this.motherJob.length > 40) {
        this.motherJob = this.motherJob.substr(0, 40);
        this.motherJobErr = false;
      } else {
        this.motherJobErr = false;
      }
    },
    motherEdu() {
      if (this.motherEdu.length === 0) {
        this.motherEduErr = true;
      } else if (this.motherEdu.length > 40) {
        this.motherEdu = this.motherEdu.substr(0, 40);
        this.motherEduErr = false;
      } else {
        this.motherEduErr = false;
      }
    },
    motherPhone() {
      const phonePattern = /^\(?([0-9]{4})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
      if (this.motherPhone.length > 11) {
        this.motherPhone = this.motherPhone.substr(0, 11);
        // console.log(this.message);
        this.motherPhoneErr = false;
      }
      if (this.motherPhone.match(phonePattern)
        && this.motherPhone.charAt(0) === '0'
        && this.motherPhone.charAt(1) === '9') {
        this.motherPhoneErr = false;
      } else {
        this.motherPhoneErr = true;
      }
    },
    melli() {
      if (this.melli.length === 10) {
        this.melliErr = false;
      } else if (this.melli.length > 10) {
        this.melli = this.melli.substr(0, 10);
        this.melliErr = false;
      } else {
        this.melliErr = true;
      }
    },
    startDate() {
      if (this.startDate !== '') {
        // console.log('date', this.startDate);
        this.startDateShow = moment(this.startDate, 'YYYY-MM-DDTHH:mm')
          .locale('FA')
          .format('jDD jMMMM jYYYY');
        this.stErr = false;
      } else {
        this.startDateShow = '';
        this.stErr = true;
      }
    },
    endDate() {
      if (this.endDate !== '') {
        // console.log('date', this.endDate);
        this.endDateShow = moment(this.endDate, 'YYYY-MM-DDTHH:mm')
          .locale('FA')
          .format('jDD jMMMM jYYYY');
        this.etErr = false;
      } else {
        this.endDateShow = '';
        this.etErr = true;
      }
    },
    payAmount() {
      let p = this.payAmount;
      p = p.replace(/,/g, '');
      if (!/^\d+$/.test(p) || (p.charAt(0) === '0' || p.charAt(0) === 0)) {
        p = p.substr(0, p.length - 1);
      }
      if (p.length > 12) {
        this.payAmount = this.payAmount.substr(0, 12);
      }
      p = this.commaSep(p);
      this.payAmount = p;
      if (this.payAmount.length > 3) {
        this.payAmountErr = false;
      } else {
        this.payAmountErr = true;
      }
    },
    classDate() {
      if (this.classDate !== '') {
        // console.log('date', this.payDate);
        this.classDateShow = moment(this.classDate, 'YYYY-MM-DDTHH:mm')
          .locale('FA')
          .format('jDD jMMMM jYYYY, ساعت HH:mm');
        this.classDateErr = false;
      } else {
        this.classDateErr = true;
        this.classDateShow = '';
      }
    },
    classDesc() {
      if (this.classDesc.length === 0) {
        this.classDescErr = true;
      } else if (this.classDesc.length > 128) {
        this.classDesc = this.classDesc.substr(0, 128);
        this.classDescErr = false;
      } else {
        this.classDescErr = false;
      }
    },
    classTitle() {
      if (this.classTitle.length === 0) {
        this.classTitleErr = true;
      } else if (this.classTitle.length > 128) {
        this.classTitle = this.classTitle.substr(0, 128);
        this.classTitleErr = false;
      } else {
        this.classTitleErr = false;
      }
    },
    classDuration() {
      if (this.classDuration < 15 || this.classDuration === undefined) {
        this.classDurationErr = true;
      } else {
        this.classDurationErr = false;
      }
    },
    classServer() {
      if (this.classServer === '') {
        this.classServerErr = true;
      } else {
        this.classServerErr = false;
      }
    },
    classGrade() {
      if (this.classGrade === '') {
        this.classGradeErr = true;
      } else {
        this.classGradeErr = false;
      }
    },
    classField() {
      if (this.classField === '') {
        this.classFieldErr = true;
      } else {
        this.classFieldErr = false;
      }
    },
    classLesson() {
      if (this.classLesson === '') {
        this.classLessonErr = true;
      } else {
        this.classLessonErr = false;
      }
    },
    // class manager
    classSearch() {
      this.isTyping = true;
      this.sec = 2000;
      clearInterval(this.isTypingInterval);
      this.isTypingInterval = setInterval(() => {
        this.sec -= 10;
        if (this.sec === 0) {
          clearInterval(this.isTypingInterval);
          this.isTyping = false;
        }
      }, 1);
    },
    classRange() {
      if (this.classRange.length === 2) {
        // console.log('date', this.payDate);
        let s = '';
        s += moment(this.classRange[0], 'YYYY-MM-DDTHH:mm')
          .locale('FA')
          .format('jYYYY/jMM/jDD');
        s += moment(this.classRange[1], 'YYYY-MM-DDTHH:mm')
          .locale('FA')
          .format(' --> jYYYY/jMM/jDD');
        this.classRangeShow = s;
        this.classRangeErr = false;
      } else {
        this.classRangeErr = true;
        this.classRangeShow = '';
      }
    },
    conventionName() {
      if (this.conventionName.length === 0) {
        this.adNameErr = true;
      } else if (this.conventionName.length > 24) {
        this.conventionName = this.conventionName.substr(0, 24);
        this.adNameErr = false;
      } else {
        this.adNameErr = false;
      }
    },
    conventionFamily() {
      if (this.conventionFamily.length === 0) {
        this.adFamilyErr = true;
      } else if (this.conventionFamily.length > 24) {
        this.conventionFamily = this.conventionFamily.substr(0, 24);
        this.adFamilyErr = false;
      } else {
        this.adFamilyErr = false;
      }
    },
    conventionPhone() {
      const phonePattern = /^\(?([0-9]{4})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
      if (this.conventionPhone.length > 11) {
        this.conventionPhone = this.conventionPhone.substr(0, 11);
        // console.log(this.message);
        this.adPhoneErr = false;
      }
      if (this.conventionPhone.match(phonePattern)
        && this.conventionPhone.charAt(0) === '0'
        && this.conventionPhone.charAt(1) === '9') {
        this.adPhoneErr = false;
      } else {
        this.adPhoneErr = true;
      }
    },
  },
  computed: {
    isFormReady() {
      const a = !this.nameErr
        && !this.lastNameErr
        && !this.fatherErr
        && !this.melliErr
        && !this.stErr
        && !this.etErr
        && !this.fieldErr
        && !this.planErr
        && this.isPayReady;
      return a;
    },
    isConventionReady() {
      const a = !this.adNameErr
        && !this.adFamilyErr
        && !this.adPhoneErr;
      return a;
    },
    computedInitImage() {
      const cii = 'none';
      // if () {
      //   return cii;
      // }
      return cii;
    },
  },
  mounted() {
    this.randomUserName();
    this.makePassWord();
    this.$store.commit('setLoadingOff');
  },
};
</script>

<style lang="scss" scoped>
$azadSecondary: #8e9bd6;
$azadPrimary: #2156ae;
$azadNormalText: #343434;
$azadDarkText: #131313;
$azadInvertText: #fafafa;
// new for exam ↓↓↓
.bank {
  margin-top: 16px;
  .bankList {
    width: 380px;
    min-height: 312px;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 0 16px 0 rgba($color: #000000, $alpha: 0.05),
      0 8px 8px 0 rgba($color: #000000, $alpha: 0.1);
    span.h {
      padding: 16px;
      border-bottom: 1px dashed rgba(0, 0, 0, 0.11);
    }
    .filterBox {
      padding: 8px;
    }
    ul {
      padding: 0;
      margin: 0;
      li {
        list-style-type: none;
        padding: 16px;
        border-bottom: 1px solid rgba($color: #000000, $alpha: 0.05);
        .qindex {
          width: 24px;
          min-width: 24px;
          font-size: 10px;
          font-weight: 300;
          text-align: right;
        }
        .qQuestion {
          span.q {
            font-size: 13px;
            font-weight: 200;
            text-align: right;
          }
          i {
            margin-left: 8px;
            opacity: 0.5;
            transition: all ease-in-out 0.3s;
          }
          i:hover {
            opacity: 1;
          }
          i.hard {
            color: rgb(206, 0, 0);
          }
          i.normal {
            color: rgb(27, 190, 49);
          }
          i.easy {
            color: rgb(54, 101, 161);
          }
        }
        .qAddToList {
          width: 32px;
          min-width: 32px;
          margin-right: 16px;
          i {
            font-size: 16px;
          }
        }
      }
      li:hover {
        background-color: rgba($color: #000000, $alpha: 0.05);
        border-bottom: 1px solid rgba($color: #000000, $alpha: 0.0);
      }
    }
  }
}
// new for exam ↑↑↑
  .counter{
    min-width: 96px;
    label{
      font-weight: bold;
      margin-right: 8px;
      font-size: 32px;
      color: rgba($color: #363636, $alpha: 1.0);
    }
    span{
      font-weight: 100;
      font-size: 12px;
      color: rgba($color: #363636, $alpha: 1.0);
    }
  }
  .courseInfoHolder {
    $iw: 204px;
    padding: 24px;
    margin-bottom: 24px;
    border-bottom: dashed 1px rgba($color: #000000, $alpha: 0.2);
    img.c{
      width: $iw;
      height: $iw;
      border-radius: 8px;
    }
    .courseTeacher{
      font-size: 16px;
      word-spacing: -2px;
      font-weight: 400;
    }
    .courseLesson{
      font-size: 13px;
      word-spacing: 0px;
      font-weight: 400;
    }
    .courseName{
      font-size: 28px;
      word-spacing: -2px;
      font-weight: 400;
      color: #61187A;
      text-align: right;
      line-height: 1.3;
      border-right: solid 4px rgba($color: #61187A, $alpha: 1);
      padding: 0px 8px 0 0;
    }
  }
  .assignments {
    box-shadow: 0 8px 16px 0 rgba($color: #000000, $alpha: 0.15);
    border-radius: 8px;
    overflow: hidden;
    .heads {
      width: 100%;
      text-align: right;
      padding: 8px;
      word-spacing: -2px;
      font-size: 14px;
      color: rgba($color: white, $alpha: 1.0);
      font-weight: 400;
      background-color: #61187A;
      i {
        margin-left: 8px;
        font-size: 16px;
        color: #f0f0f0;
        padding: 8px;
      }
    }
    ul {
      padding: 0;
      margin: 0;
      max-width: 480px;
      overflow: hidden auto;
      li {
        width: 100%;
        padding: 12px;
        list-style: none;
        text-align: right;
        span {
          width: 16px;
          font-size: 10px;
          font-weight: 200;
          text-align: right;
        }
        .title {
          font-size: 14px;
          font-weight: bold;
        }
        .desc {
          font-size: 10px;
          font-weight: 300;
        }
      }
    }
  }

  .infos{
    padding: 0 24px;
  }
  .courseId{
    padding: 2px 8px;
    font-size: 10px;
    margin-bottom: 16px;
    letter-spacing: 2px;
    border-right: solid 4px rgba($color: #000000, $alpha: 0.2);
  }
  .courseSummary{
    padding: 8px 8px 16px;
    font-size: 12px;
    text-align: right;
    color: #646464;
    border-right: solid 4px rgba($color: #000000, $alpha: 0.2);
  }

  .teacherHolder img.t{
    width: 64px;
    height: 64px;
    margin-left: 8px;
    border-radius: 80px 0 80px 80px;
  }

  .question{
    font-size: 18px;
    font-weight: 300;
    margin-bottom: 16px;
    text-align: right;
  }

  .ltr {
    direction: ltr !important;
  }

  .rules{
    margin: 24px 24px 50px;
  }

  .formSection {
    .teachers {
      .teachersResult {
        padding: 4px 8px;
        border-radius: 8px;
        margin-bottom: 8px;
        cursor: pointer;
        box-shadow: 0 2px 8px -4px rgba($color: #000000, $alpha: 0.25);
        border: solid rgba(0, 0, 0, 0.11) 2px;
        * {
          pointer-events: none;
        }
        .ava {
          min-width: 32px;
          height: 32px;
          border-radius: 50%;
          background-color: rgba($color: #000000, $alpha: 0.05);
          margin-left: 8px;
        }
        .stName {
          font-weight: 500;
          font-size: 14px;
        }
        .stPhone {
          font-size: 10px;
          font-weight: 200;
          letter-spacing: 2px;
          padding-left: 2px;
        }
      }
      .teachersResult.selected {
        border: solid rgb(127, 228, 127) 2px;
      }
      .noRes {
        padding: 32px;
        i {
          font-size: 48px;
          color: rgba($color: #000000, $alpha: 0.25);
          margin-bottom: 16px;
        }
        span {
          font-size: 16px;
          font-weight: 200;
          color: rgba($color: #000000, $alpha: 0.45);
        }
      }
    }
  }
  .classList {
    .classItem {
      padding: 8px;
      border-radius: 8px;
      // box-shadow: 0 8px 16px -4px rgba($color: #000000, $alpha: 0.25);
      border: solid 2px rgba($color: #000000, $alpha: 0.1);
      margin-bottom: 8px;
      .classIndex {
        width: 24px;
        font-size: 12px;
        font-weight: 300;
        text-align: right;
        color: rgba($color: #000000, $alpha: 0.25);
      }
      .className {
        font-size: 14px;
        font-weight: bold;
      }
      .classTeacher {
        font-weight: 300;
        font-size: 12px;
      }
      .classActions {
        .action {
          font-size: 16px;
          padding: 8px;
          border-radius: 50%;
        }
        .action:hover {
          background-color: rgba($color: #000000, $alpha: 0.05);
        }
      }
    }
  }

  .ruleBox {
    padding: 0 8px;
  }

  .uploadersHolder h3, .videoList h3 {
    width: 100%;
    text-align: right;
    padding: 8px 16px;
    word-spacing: -2px;
    font-size: 16px;
    font-weight: 400;
  }

  .uploadersHolder h4, .videoList h4 {
    width: 100%;
    text-align: right;
    padding: 8px 16px;
    word-spacing: -2px;
    font-size: 14px;
    font-weight: 200;
    position: relative;
  }

  .uploadersHolder h4::before, .videoList h4::before{
    position: absolute;
    content: ' ';
    border-radius: 50%;
    width: 8px;
    height: 8px;
    background-color: royalblue;
    left: calc(100% - 8px);
    top: 50%;
    transform: translateY(-50%);
  }

  .uploadersHolder p, .videoList p {
    width: 100%;
    text-align: right;
    padding: 0px 16px;
    word-spacing: -1px;
    font-size: 12px;
    font-weight: 200;
    margin: 0 0 4px 0;
    position: relative;
  }

  .uploadersHolder p::before, .videoList p::before{
    position: absolute;
    content: ' ';
    border-radius: 50%;
    width: 8px;
    height: 8px;
    background-color: rgba(65, 105, 225, 0.301);
    left: calc(100% - 8px);
    top: 5px;
  }

  input[type="text"], input[type='number'] {
    border-radius: 8px;
    border: solid 1px rgba($color: #000000, $alpha: 0.05);
    padding: 4px 8px;
    font-size: 13px;
    font-weight: 200;
    width: 100%;
  }

  // n
  .formHead {
    padding: 8px 0px;
    margin-bottom: 8px;
    border-right: solid 2px rgba($color: #000000, $alpha: 0.25);
    i {
      color: blue;
      margin-left: 8px;
    }
    span {
      font-size: 14px;
      font-weight: bold;
      text-align: right;
    }
  }

  .companies {
    .company {
      padding: 8px;
      border-radius: 8px;
      border: solid 2px rgba($color: $azadSecondary, $alpha: 0.25);
      margin-bottom: 4px;
      .companyIcon {
        width: 40px;
        height: 40px;
        margin-left: 8px;
        border-radius: 8px;
        background-color: rgba($color: #000000, $alpha: 0.05);
      }
      span {
        font-size: 10px;
      }
      .companyName {
        font-weight: bold;
        font-size: 14px;
        line-height: 1;
      }
    }
    .company:hover {
      border: solid 2px rgba($color: $azadSecondary, $alpha: 0.45);
    }
    .company.selected {
      border: solid 2px rgba($color: $azadSecondary, $alpha: 1);
      .companyIcon {
        background-color: rgba($color: #000000, $alpha: 0.15);
      }
    }
  }
</style>
